/**
 * Per-variant Précommande / Épuisé badges + ATC state.
 * - Épuisé → badge on photo (not under variants)
 * - Sold-out variants cannot be purchased (even if Shopify "continue selling")
 * - Précommande only for concerned colors (see ProductSellable JSON)
 *
 * Keep this light: no MutationObservers / defineProperty (those froze PDP variant UI).
 */
(function () {
  function parseSellable(sectionId) {
    var el = document.getElementById('ProductSellable-' + sectionId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function clearInventoryOutstockText(sectionRoot) {
    var tracking = sectionRoot.querySelector('.js-inventory-tracking');
    if (!tracking) return;
    tracking.querySelectorAll('.product--outstock').forEach(function (node) {
      node.remove();
    });
    if (!tracking.textContent.trim()) {
      tracking.innerHTML = '';
    }
  }

  function applyState(sectionRoot, sectionId, variantId) {
    // KNR : drapeau pour que le MutationObserver ignore nos propres modifications du DOM
    window.__preorderApplying = true;
    setTimeout(function () { window.__preorderApplying = false; }, 0);
    var data = parseSellable(sectionId);
    if (!data || !data.variants) return;

    var info = data.variants[String(variantId)] || {};
    var isPreOrder = !!info.preOrder;
    var isSoldOut = !!info.soldOut || (!isPreOrder && info.sellable === false);
    var labels = data.labels || {};
    var preOrderLabel = labels.preOrder || 'Précommande';
    var addLabel = labels.addToCart || 'Ajouter au panier';
    var soldLabel = labels.soldOut || 'Épuisé';

    var preBadge = sectionRoot.querySelector('.js-preorder-badge');
    if (preBadge) {
      if (isPreOrder) preBadge.removeAttribute('hidden');
      else preBadge.setAttribute('hidden', '');
    }

    var soldBadge = sectionRoot.querySelector('.js-soldout-badge');
    if (soldBadge) {
      if (isSoldOut && !isPreOrder) soldBadge.removeAttribute('hidden');
      else soldBadge.setAttribute('hidden', '');
    }

    var lead = sectionRoot.querySelector('.js-preorder-lead-time');
    if (lead) {
      if (isPreOrder) lead.removeAttribute('hidden');
      else lead.setAttribute('hidden', '');
    }

    clearInventoryOutstockText(sectionRoot);

    var form = sectionRoot.querySelector('sht-prd-frm[data-section="' + sectionId + '"]');
    if (form) {
      if (isPreOrder) form.setAttribute('data-pre-order', 'true');
      else form.removeAttribute('data-pre-order');
      if (isSoldOut) form.setAttribute('data-out-of-stock', 'true');
      else form.removeAttribute('data-out-of-stock');
    }

    function setBtn(span) {
      if (!span) return;
      var btn = span.closest('button');
      if (!btn) {
        span.textContent = isPreOrder ? preOrderLabel : isSoldOut ? soldLabel : addLabel;
        return;
      }

      if (isPreOrder) {
        btn.removeAttribute('disabled');
        span.textContent = preOrderLabel;
      } else if (isSoldOut) {
        btn.setAttribute('disabled', 'disabled');
        span.textContent = soldLabel;
      } else {
        btn.removeAttribute('disabled');
        span.textContent = addLabel;
      }
    }

    sectionRoot.querySelectorAll('.js-product-form-submit-btn-text').forEach(setBtn);

    var stickyRoot = document.getElementById('productStickyInfo-' + sectionId);
    if (stickyRoot) {
      stickyRoot.querySelectorAll('.js-product-form-submit-btn-text').forEach(setBtn);
    }
  }

  function readVariantId(sectionRoot, sectionId) {
    var input =
      sectionRoot.querySelector('#productForm-' + sectionId + ' input[name="id"]') ||
      sectionRoot.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    return input ? String(input.value || '') : '';
  }

  function bindSection(sectionRoot) {
    var form = sectionRoot.querySelector('sht-prd-frm[data-section]');
    if (!form) return;
    var sectionId = form.dataset.section;
    if (!sectionId || form.dataset.preorderBound === 'true') return;
    form.dataset.preorderBound = 'true';

    var timer = null;
    var sync = function () {
      var id = readVariantId(sectionRoot, sectionId);
      if (!id) return;
      applyState(sectionRoot, sectionId, id);
    };

    var syncDebounced = function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(sync, 40);
      // KNR : le thème re-rend le bouton via fetch apres un changement de variante,
      // parfois APRES notre sync -> on re-synchronise en rafale pour couvrir la course.
      [250, 600, 1200, 2500].forEach(function (d) { setTimeout(sync, d); });
    };

    sectionRoot.addEventListener('change', syncDebounced);
    sectionRoot.addEventListener(
      'click',
      function (e) {
        if (
          e.target.closest(
            '.js-variant-radio-item, .product-option__label, label.product-option__label, .product-swatches, .variant-swatchs'
          )
        ) {
          syncDebounced();
        }
      },
      true
    );

    // KNR : si le thème remplace le HTML de la section (rendu de variante), on re-synchronise
    new MutationObserver(function () {
      if (!window.__preorderApplying) syncDebounced();
    }).observe(sectionRoot, { childList: true, subtree: true });

    sync();
    setTimeout(sync, 300);
  }

  function init() {
    document.querySelectorAll('[data-ui-component="Main Product Section"]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 0);
  });
})();
